import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

// SCRUM-976: useParams() only exposes the params matched by the specific <Route> a
// component is rendered inside of. Components rendered as modal siblings of <Routes>
// (e.g. Mk2DecoderModalV2, ReviewDecodersView) or as the ancestor that renders <Routes>
// (SetUpContainer) sit outside the matched setup_first/:id, discovery/:id route subtree,
// so useParams() there always returns undefined. Derive the id from the URL's last
// numeric path segment instead, which works regardless of render position.
export const useSetupUrlInterfaceId = (): string | undefined => {
  const location = useLocation()

  return useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean)
    const last = segments[segments.length - 1]
    return last && /^\d+$/.test(last) ? last : undefined
  }, [location.pathname])
}

export default useSetupUrlInterfaceId
